var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _circle, _path13, _circle2, _path14, _circle3, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAirlineTickets(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Filled",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m71.9 191.248v177.237a15.254 15.254 0 0 0 14.982 15.515h274.139a15.254 15.254 0 0 0 14.979-15.515v-177.237a15.254 15.254 0 0 0 -14.979-15.515h-274.139a15.254 15.254 0 0 0 -14.982 15.515z",
    fill: "#e1e3e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m474.3 175.733h-84.6c-7.566 0-13.7 6.946-13.7 15.515v177.237c0 8.569 6.134 15.515 13.7 15.515h84.6c7.566 0 13.7-6.946 13.7-15.515v-177.237c0-8.569-6.134-15.515-13.7-15.515z",
    fill: "#d0d2d4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m376 191.243v32.757h-304.1v-32.76a15.258 15.258 0 0 1 14.98-15.51h274.14a15.258 15.258 0 0 1 14.98 15.513z",
    fill: "#eb423f"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m488 191.243v32.757h-112v-32.76c0-8.56 6.13-15.51 13.7-15.51h84.6c7.57.003 13.7 6.953 13.7 15.513z",
    fill: "#eb423f"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#c3c6c7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m296 280h-48a8 8 0 0 1 0-16h48a8 8 0 0 1 0 16z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 328,
    cy: 272,
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m296 312h-48a8 8 0 0 1 0-16h48a8 8 0 0 1 0 16z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 328,
    cy: 304,
    r: 8
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m23.9 143.515v177.237a15.254 15.254 0 0 0 14.979 15.515h274.142a15.254 15.254 0 0 0 14.979-15.515v-177.237a15.254 15.254 0 0 0 -14.979-15.515h-274.139a15.254 15.254 0 0 0 -14.982 15.515z",
    fill: "#e9eef2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m426.3 128h-84.6c-7.566 0-13.7 6.946-13.7 15.515v177.237c0 8.569 6.134 15.515 13.7 15.515h84.6c7.566 0 13.7-6.946 13.7-15.515v-177.237c0-8.569-6.134-15.515-13.7-15.515z",
    fill: "#dadcde"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m328 143.51v32.76h-304.1v-32.76a15.258 15.258 0 0 1 14.98-15.51h274.14a15.258 15.258 0 0 1 14.98 15.51z",
    fill: "#eb423f"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m440 143.51v32.76h-112v-32.76c0-8.56 6.13-15.51 13.7-15.51h84.6c7.57 0 13.7 6.95 13.7 15.51z",
    fill: "#eb423f"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m474.4 168h-26.4v-24.485c0-12.966-9.734-23.515-21.7-23.515h-84.6a20.63 20.63 0 0 0 -13.929 5.5 22.564 22.564 0 0 0 -14.75-5.5h-274.139c-12.67 0-22.982 10.549-22.982 23.515v177.237c0 12.966 10.309 23.515 22.979 23.515h25.097l-.076 24.485c0 12.966 10.309 23.515 22.979 23.515h274.142a22.565 22.565 0 0 0 14.8-5.546 20.633 20.633 0 0 0 13.976 5.546h84.6c11.965 0 21.7-10.549 21.7-23.515v-177.237c.003-12.966-9.735-23.515-21.697-23.515zm-138.4-24.485c0-4.074 2.61-7.515 5.7-7.515h84.6c3.09 0 5.7 3.441 5.7 7.515v24.752h-96zm-304.1 0a7.27 7.27 0 0 1 6.982-7.515h274.139a7.27 7.27 0 0 1 6.979 7.515v24.752h-288.1zm6.979 184.752a7.27 7.27 0 0 1 -6.979-7.515v-136.485h288.1v136.485a7.27 7.27 0 0 1 -6.979 7.515zm329.221 40.485h-.1a7.27 7.27 0 0 1 -6.979 7.515h-274.139a7.264 7.264 0 0 1 -6.979-7.491l.073-24.509h233.045a22.564 22.564 0 0 0 14.75-5.5 20.63 20.63 0 0 0 13.929 5.5h26.4zm-26.4-40.485c-3.09 0-5.7-3.441-5.7-7.515v-136.485h96v136.485c0 4.074-2.61 7.515-5.7 7.515zm138.4 40.485c0 4.074-2.611 7.515-5.7 7.515h-84.6c-3.09 0-5.7-3.441-5.7-7.515v-24.485h42.2c11.966 0 21.7-10.549 21.7-23.515v-96.217h32.1zm0-160.217h-32.1v-24.535h26.4c3.089 0 5.7 3.441 5.7 7.515z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m248 216.267h-48a8 8 0 0 0 0 16h48a8 8 0 0 0 0-16z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m408 216.267h-48a8 8 0 0 0 0 16h48a8 8 0 0 0 0-16z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m408 248.267h-48a8 8 0 0 0 0 16h48a8 8 0 0 0 0-16z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 224.267,
    r: 8
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m248 248.267h-48a8 8 0 0 0 0 16h48a8 8 0 0 0 0-16z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 256.267,
    r: 8
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m248 280.267h-48a8 8 0 0 0 0 16h48a8 8 0 1 0 0-16z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 288.267,
    r: 8
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m152.1 248.267h-19.059l-13.789-27.578a8 8 0 0 0 -14.311 7.156l10.212 20.422h-35.053v-16a8 8 0 0 0 -16 0v24a8 8 0 0 0 8 8h43.056l-10.212 20.422a8 8 0 1 0 14.311 7.156l13.789-27.578h19.056a8 8 0 1 0 0-16z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirlineTickets);
export default __webpack_public_path__ + "static/media/Airline_Tickets.9375c0904d612b988c533d4fea634280.svg";
export { ForwardRef as ReactComponent };